import { ButtonLink } from '@asgard/ui-library';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2, Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import Link from 'next/link';
import { useRouter } from 'next/router';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import {
  StyledBanner,
  StyledContainer,
  StyledFunnel,
  StyledSignup,
  StyledValue,
  StyledWrapper
} from './Methodology.styled';

const Methodology: React.FC = () => {
  const { t } = useI18n('state-of-hiring');
  const { locale } = useRouter();

  const funnelData = [
    { value: 1094, desc: t('state-of-hiring.methodology.companies-contacted') },
    { value: 1030, desc: t('state-of-hiring.methodology.companies-worked') },
    { value: 800, desc: t('state-of-hiring.methodology.companies-processes') },
    { value: 370, desc: t('state-of-hiring.methodology.companies-hired') }
  ];

  return (
    <StyledWrapper>
      <StyledContainer>
        <Heading2 editorial>{t('state-of-hiring.methodology.title')}</Heading2>
        <HtmlTrans
          i18nKey="state-of-hiring.methodology.content"
          ns="state-of-hiring"
        />
        {funnelData.map((item, index) => (
          <StyledFunnel key={index}>
            <div>
              <StyledValue>{item.value}</StyledValue>
              {item.desc}
            </div>
          </StyledFunnel>
        ))}
        <StyledBanner>
          <Heading3 editorial>
            {t('state-of-hiring.methodology.banner-title')}
          </Heading3>
          <p>{t('state-of-hiring.methodology.banner-desc')}</p>
          <div>
            <Link
              href={`https://getmanfred.typeform.com/to/ImCbPV97?source=state-of-hiring`}
              passHref
              target="_blank"
              rel="noreferrer"
            >
              <ButtonLink
                schema="brand2"
                variant="hard"
                href="#"
                startIcon={faBriefcase}
                label={t('state-of-hiring.methodology.cta-companies')}
                onClick={() =>
                  ServiceEventTracking.trackLandingCtaClicked(
                    'footer-empresas-hiring-report'
                  )
                }
              />
            </Link>
          </div>
          <StyledSignup>
            <HtmlTrans
              i18nKey="state-of-hiring.methodology.cta-register"
              ns="state-of-hiring"
              components={{
                signupLink: (
                  <a
                    href={`${getAppUrl(
                      APP_URLS.join,
                      locale
                    )}?locale=${locale}&source=footer-unete-hiring-report`}
                    onClick={(e) =>
                      ServiceEventTracking.trackExternalLandingCtaClicked(
                        e,
                        `${getAppUrl(
                          APP_URLS.join,
                          locale
                        )}?locale=${locale}&source=footer-unete-hiring-report`,
                        'footer-unete-hiring-report'
                      )
                    }
                  />
                )
              }}
            />
          </StyledSignup>
        </StyledBanner>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Methodology;
